export const mapOrderItemPunchOutSupplier = (punchoutSupplierData: {
  punchout_supplier_can_update_quantity: Nullable<boolean>
  punchout_supplier_icon: Nullable<string>
  punchout_supplier_name: Nullable<string>
  punchout_vendor_reference: Nullable<number>
}) => {
  if (
    !punchoutSupplierData.punchout_supplier_icon ||
    !punchoutSupplierData.punchout_supplier_name ||
    punchoutSupplierData.punchout_vendor_reference === null
  )
    return null

  return {
    id: punchoutSupplierData.punchout_vendor_reference,
    icon: punchoutSupplierData.punchout_supplier_icon,
    name: punchoutSupplierData.punchout_supplier_name,
    canEditQuantity: Boolean(
      punchoutSupplierData.punchout_supplier_can_update_quantity
    ),
  }
}
